import React, { useState, useEffect } from "react";
import { Modal } from "antd";

import { IconBack } from "../../assets/index";
import "./Login.scss";

import ForgotPassword1 from "./component/ForgotPassword1";
import ForgotPassword2 from "./component/ForgotPassword2";
import ForgotPassword3 from "./component/ForgotPassword3";

const RegisterModal = ({
  visible,
  handleVisible = () => {},
  handleSelectItem = () => {},
}) => {
  const [step, setStep] = useState(1);
  const [dataForm, setDataForm] = useState({});
  useEffect(() => {
    setStep(1);
  }, []);

  const handleChangeStep = (valueStep = 1) => {
    setStep(valueStep);
    if (valueStep === 4) {
      handleVisible("LOGIN_MODAL");
    }
  };

  const handleChangeDataForm = (data = {}) => {
    setDataForm(data);
  };

  const handleBack = () => {
    setStep(step - 1);
  };

  return (
    <Modal
      title="Khôi phục mật khẩu"
      centered
      visible={visible}
      onCancel={handleVisible}
      className="modal-login"
      width={400}
    >
      {step !== 1 && (
        <div className="btn-back" onClick={handleBack}>
          <IconBack />
        </div>
      )}
      {step === 1 ? (
        <ForgotPassword1
          handleChangeStep={handleChangeStep}
          handleVisible={handleVisible}
          dataForm={dataForm}
          handleChangeDataForm={handleChangeDataForm}
        />
      ) : step === 2 ? (
        <ForgotPassword2
          handleChangeStep={handleChangeStep}
          dataForm={dataForm}
          handleChangeDataForm={handleChangeDataForm}
        />
      ) : (
        <ForgotPassword3
          handleChangeStep={handleChangeStep}
          dataForm={dataForm}
          handleChangeDataForm={handleChangeDataForm}
        />
      )}
    </Modal>
  );
};

export default RegisterModal;
